import { Button } from "@mui/material";
import { textColorState } from "@/lib/store";
import { useAtomValue } from "jotai";
import { FC, useContext, ReactNode } from "react";
import { ModuleContext } from "@/lib/Context";

interface outlinedBtnConfig {
    children?: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    icon?: any;
}

// to be used on Module header for now
const OutlinedBtn: FC<outlinedBtnConfig> = ({ onClick, children, disabled = false, icon = null }) => {
    const { obfuscated } = useContext(ModuleContext);
    const textColor = useAtomValue(textColorState);

    return (
        <Button size="small" variant="outlined" sx={{ color: textColor, fontSize: 12, height: { xs: "auto", sm: 26 }, padding: "3px 5px", textTransform: "none", mr: 1 }} onClick={onClick} disabled={obfuscated || disabled} endIcon={icon}>
            {children}
        </Button>
    );
};

export default OutlinedBtn;
